import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { LanguageProvider } from "./screens/Authentication/LanguageContext";
import MainStack from "../src/screens/MainScreen/MainStack";

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <Router>
        <MainStack />
      </Router>
    </LanguageProvider>
  );
};

export default App;
